import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import LoadingBox from 'components/Common/Loading/LoadingBox'
import { tripItemsMaxWidth } from 'tripPlanner/config'

const CardLoadingBox = styled(LoadingBox)`
  border-radius: ${(props) => props.theme.borderRadius.large};
  max-width: ${tripItemsMaxWidth};
`

interface Props {
  height: number
}

function TripSummaryCardLoadingSkeleton(props: Props) {
  return <CardLoadingBox style={{ height: rem(props.height) }} />
}

TripSummaryCardLoadingSkeleton.defaultProps = {
  height: 148,
}

export default TripSummaryCardLoadingSkeleton
